// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"6702c948","453":"8cfde039","521":"4578c2a1","795":"87f069c3","829":"1ab2f623"}[chunkId] + ".chunk.js";
};